<template>
  <div class="wrapper">
    <progressBar
      :getCurrentStep="getCurrentFreeBetProgress"
      :getTotalStep="getTotalFreeBetProgress"
      :isProgress="true"
      :isShowCheck="isFullProgress"
      :styleCheck="styleCheck"
      :type="type" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import progressBar from '@/components/progress/ProgressBar.vue';

export default Vue.extend({
  name: 'ProgressBarCheck',
  components: { progressBar },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'isLandscape',
      'getUiPosition',
      'getCurrentFreeBetProgress',
      'getTotalFreeBetProgress',
      'getIsMobile'
    ]),
    styleCheck(): any {
      return {
        rightCheck: this.rightCheck,
        leftCheck: this.leftCheck,
        topCheck: this.topCheck,
        scaleCheck: this.scaleCheck
      };
    },
    isFullProgress(): boolean {
      return Number(this.getCurrentFreeBetProgress) >= Number(this.getTotalFreeBetProgress);
    },

    rightCheck(): number {
      return this.isLandscape
        ? this.getUiPosition.landscape.progressCheck.right
        : this.getUiPosition.portrait.progressCheck.right;
    },
    leftCheck(): number {
      return this.isLandscape
        ? this.getUiPosition.landscape.progressCheck.left
        : this.getUiPosition.portrait.progressCheck.left;
    },
    topCheck(): number {
      const topLandscapeMobile: number = this.getUiPosition.mobile.landscape.progressCheck.top;
      if (this.isLandscape && this.getIsMobile && topLandscapeMobile) {
        return topLandscapeMobile;
      }
      return this.isLandscape
        ? this.getUiPosition.landscape.progressCheck.top
        : this.getUiPosition.portrait.progressCheck.top;
    },
    scaleCheck(): number {
      return this.isLandscape
        ? this.getUiPosition.landscape.progressCheck.scale
        : this.getUiPosition.portrait.progressCheck.scale;
    }
  }
});
</script>

<style scoped></style>